import { INavData } from '@coreui/angular';
import { API_BASE, SNOMEDCT_BROWSER_URL, DMKT_BROWSER_URL } from 'src/shared/common';

interface INavDataExtended extends INavData {
    _mobileDisabled?: boolean;
}

export const navItems: INavDataExtended[] = [
    {
        name: 'ICD Smart Search',
        url: 'search/search-global',
        iconComponent: { name: 'cilMagnifyingGlass' },
    },
    {
        name: 'Assistants',
        url: '/chatbot',
        iconComponent: { name: 'cilSpeech' },
        badge: { text: 'AI', color: 'info' },
        children: [
            {
                name: 'ICD-10 Sense',
                url: '/chatbot/icd-10',
                badge: { text: 'Hot', color: 'danger' },
            },
            {
                name: 'ICD-9 Sense',
                url: '/chatbot/icd-9',
            },
            {
                name: 'ICF Sense',
                url: '/chatbot/icf',
            },
            {
                name: 'DMKT Sense',
                url: 'https://sensesphere.ai/chat/?theme=dark&uuid=6a189785-92fe-4719-9e59-0efe9dac66cc',
                badge: { text: 'Mới', color: 'primary' },
            },
        ],
    },
    // {
    //     name: 'Bảng thống kê',
    //     url: '',
    //     iconComponent: { name: 'cil-chart-pie' },
    //     children: [
    //         // {
    //         //     name: 'Hệ thống',
    //         //     url: '/dashboard/system',
    //         // },
    //         {
    //             name: 'UCOD',
    //             url: '/dashboard/ucod',
    //         },
    //         {
    //             name: 'MCCD',
    //             url: '/dashboard/mccd',
    //         },
    //     ],
    // },
    {
        name: 'Công cụ',
        url: '/tools',
        iconComponent: { name: 'cilLayers' },
        _mobileDisabled: true,
        class: 'mobile-disabled-group',
        children: [
             {
                name: 'UCOD Việt Nam',
                 url: '/tools/ucod',
             },
            //  {
            //      name:'UCOD Việt Nam',
            //      url: 'tools/ucod',

            //  },
            // {
            //     name: 'DRG Việt Nam',
            //     url: '/tools/drg',
            // },
            {
                name: 'DRG Việt Nam',
                url: '/tools/drg',
            },
        ],
    },
    {
        name: 'ICD-10',
        url: '/icd-10-tt06',
        iconComponent: { name: 'cilTags' },
        badge: { text: '06/2026/TT-BYT', color: 'info' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icd-10-tt06/icd10-tt06',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icd-10-tt06/icd10-tt06-dual',
            },
            {
                name: 'YHCT',
                url: '/yhct/yhct-1978',
                badge: { text: '1978/QĐ-BYT', color: 'success' },
            },
            {
                name: 'Tài liệu ICD-10',
                url: '/icd-10/instruction-icd10',
            },
        ],
    },
    {
        name: 'ICD-10',
        url: '/icd-10',
        iconComponent: { name: 'cilCode' },
        badge: { text: 'Bản trước', color: 'secondary' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icd-10/icd10',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icd-10/icd10-dual',
            },
            {
                name: 'YHCT',
                url: '/yhct/yhct-7603',
                badge: { text: '7603/QĐ-BYT', color: 'success' },
            },
            {
                name: 'Tài liệu ICD-10',
                url: '/icd-10/instruction-icd10',
            },
            // {
            //     name: 'ICD10-V3',
            //     url: '/icd-10/icd10v3',
            // },
        ],
    },
    // {
    //     name: 'ICD-11',
    //     url: '/icd-11',
    //     iconComponent: { name: 'cilSun' },
    //     children: [
    //         {
    //             name: 'ICD-11',
    //             url: '/icd-11/icd11',
    //         },
    //         {
    //             name: 'ICD-10 (Song ngữ)',
    //             url: '/icd-10/icd10-dual',
    //         },
    //         {
    //             name: 'Tài liệu ICD-10',
    //             url: '/icd-10/instruction-icd10',
    //         },
    //     ],
    // },
    {
        name: 'ICD-9 CM',
        url: '/icd-9',
        iconComponent: { name: 'cilFile' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icd-9/icd9',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icd-9/icd9-dual',
            },
            {
                name: 'Tài liệu ICD-9 CM',
                url: '/icd-9/instruction-icd9',
            },
        ],
    },
    {
        name: 'ICF',
        url: '/icf',
        iconComponent: { name: 'cilPeople' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icf/icf',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icf/icf-dual',
            },
            {
                name: 'ICF Core Sets',
                url: `${API_BASE}/vi/ICF/home`,
                badge: { text: 'Thử nghiệm', color: 'warning' },
            },
            {
                name: 'Tài liệu ICF',
                url: '/icf/instruction-icf',
            },
        ],
    },
    {
        name: 'EMR Form',
        url: '/emr-form',
        iconComponent: { name: 'cilNotes' },
        _mobileDisabled: true,
        class: 'mobile-disabled-group',
        children: [
            {
                name: 'EMR Form',
                url: '/emr-form',
            },
            {
                name: 'LOINC Table',
                url: '/loinc-table',
            },
        ],
    },
    {
        name: 'SNOMED CT',
        url: SNOMEDCT_BROWSER_URL,
        iconComponent: { name: 'cilSpeedometer' },
    },
    {
        name: 'Danh mục Kĩ thuật',
        url: DMKT_BROWSER_URL,
        iconComponent: { name: 'cilListNumbered' },
    },
    {
        name: 'Có gì mới ?',
        url: '/notification/notification-list',
        iconComponent: { name: 'cilBell' },
    },
];

export const navItems2: INavDataExtended[] = [
    // {
    //     title: true,
    //     name: 'apps',
    // },
    {
        name: 'ICD Smart Search',
        url: 'search/search-global',
        iconComponent: { name: 'cilMagnifyingGlass' },
    },
    {
        name: 'AI Assistants',
        url: '/chatbot',
        iconComponent: { name: 'cilSpeech' },
        badge: { text: 'AI', color: 'info' },
        children: [
            {
                name: 'ICD-10 Sense',
                url: '/chatbot/icd-10',
                badge: { text: 'Hot', color: 'danger' },
            },
            {
                name: 'ICD-9 Sense',
                url: '/chatbot/icd-9',
            },
            {
                name: 'ICF Sense',
                url: '/chatbot/icf',
            },
            {
                name: 'DMKT Sense',
                url: 'https://sensesphere.ai/chat/?theme=dark&uuid=6a189785-92fe-4719-9e59-0efe9dac66cc',
                badge: { text: 'Mới', color: 'primary' },
            },
        ],
    },
    // {
    //     name: 'Bảng thống kê',
    //     url: '/apps',
    //     iconComponent: { name: 'cil-chart-pie' },
    //     children: [
    //         // {
    //         //     name: 'Hệ thống',
    //         //     url: '/apps/dashboard/system',
    //         // },
    //         {
    //             name: 'UCOD',
    //             url: '/apps/dashboard/ucod',
    //         },
    //         {
    //             name: 'MCCD',
    //             url: '/apps/dashboard/mccd',
    //         },
    //     ],
    // },
    {
        name: 'Công cụ',
        url: '/tools',
        iconComponent: { name: 'cilLayers' },
        _mobileDisabled: true,
        class: 'mobile-disabled-group',
        children: [
            {
                name: 'UCOD Việt Nam',
                url: '/tools/ucod',
            },
            // {
            //     name:'UCOD Việt Nam',
            //     url: 'tools/ucod',

            // },
            // {
            //     name: 'DRG Việt Nam',
            //     url: '/tools/drg',
            // },
            {
                name: 'DRG Việt Nam',
                url: '/tools/drg',
            },
        ],
    },
    {
        name: 'ICD-10 06/2026/TT-BYT',
        url: '/icd-10-tt06',
        iconComponent: { name: 'cilTags' },
        badge: { text: '06/2026/TT-BYT', color: 'info' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icd-10-tt06/icd10-tt06',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icd-10-tt06/icd10-tt06-dual',
            },
            {
                name: 'Tài liệu ICD-10',
                url: '/icd-10/instruction-icd10',
            },
        ],
    },
    {
        name: 'ICD-10',
        url: '/icd-10',
        iconComponent: { name: 'cilCode' },
        badge: { text: 'Bản trước', color: 'secondary' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icd-10/icd10',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icd-10/icd10-dual',
            },
            {
                name: 'Tài liệu ICD-10',
                url: '/icd-10/instruction-icd10',
            },
            // {
            //     name: 'ICD-10 V3',
            //     url: '/icd10/icd10v3',
            // }
         
        ],

    },
    {
        name: 'ICD-9 CM',
        url: '/icd-9',
        iconComponent: { name: 'cilFile' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icd-9/icd9',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icd-9/icd9-dual',
            },
            {
                name: 'Tài liệu ICD-9 CM',
                url: '/icd-9/instruction-icd9',
            },
        ],
    },
    {
        name: 'ICF',
        url: '/icf',
        iconComponent: { name: 'cilPeople' },
        children: [
            {
                name: 'Tra cứu',
                url: '/icf/icf',
            },
            {
                name: 'Tra cứu song ngữ',
                url: '/icf/icf-dual',
            },
            {
                name: 'ICF Core Sets',
                url: `${API_BASE}/vi/ICF/home`,
                badge: { text: 'Thử nghiệm', color: 'warning' },
            },
            {
                name: 'Tài liệu ICF',
                url: '/icf/instruction-icf',
            },
        ],
    },

    {
        name: 'EMR Form',
        url: '/emr-form',
        iconComponent: { name: 'cilNotes' },
        _mobileDisabled: true,
        class: 'mobile-disabled-group',
    },
    {
        name: 'LOINC Table',
        url: '/loinc-table',
        iconComponent: { name: 'cilList' },
    },
    {
        name: 'SNOMED CT',
        url: SNOMEDCT_BROWSER_URL,
        iconComponent: { name: 'cilSpeedometer' },
    },
    {
        name: 'Danh mục Kĩ thuật',
        url: DMKT_BROWSER_URL,
        iconComponent: { name: 'cilListNumbered' },
    },
    {
        name: 'Có gì mới ?',
        url: '/notification/notification-list',
        iconComponent: { name: 'cilBell' },
    },
];
